import React, { useEffect, useState } from 'react'
import { Badge, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

import ChatService from '../services/ChatService'

import NotificationList from './common/NotificationList'
import FAIcon from './FAIcon'

import './TopNav.scss'

const TopNav = props => {
  const [chatUnreadCount, setChatUnreadCount] = useState(0)

  // Polling Effects
  useEffect(() => {
    if (props.currentUser && Object.keys(props.currentUser).length !== 0) {
      // Initial Load
      pollChat()

      // Listeners
      const handleChatRefresh = () => pollChat()
      const handleChatMarkAll = () => {
        setChatUnreadCount(0)
        setTimeout(pollChat, 2000)
      }
      const handleNewChatMessage = e => {
        const msg = e.detail
        // If I am not the sender, increment unread count
        // Note: If ChatRoom is open, it will mark read and trigger refresh, correcting this.
        if (msg.senderUserId !== props.currentUser.id) {
          setChatUnreadCount(prev => prev + 1)
        }
      }

      window.addEventListener('chat:refresh-unread', handleChatRefresh)
      window.addEventListener('chat:mark-all-read', handleChatMarkAll)
      window.addEventListener('chat-message', handleNewChatMessage)

      return () => {
        window.removeEventListener('chat:refresh-unread', handleChatRefresh)
        window.removeEventListener('chat:mark-all-read', handleChatMarkAll)
        window.removeEventListener('chat-message', handleNewChatMessage)
      }
    }
  }, [props.currentUser])

  const pollChat = async () => {
    try {
      const count = await ChatService.getUnreadCount()
      setChatUnreadCount(count)
    } catch (err) {
      console.error('Failed to poll chat unread', err)
    }
  }

  /* Close trays on navigation */
  const location = useLocation()
  useEffect(() => {
    // Close Chat
    if (props.isChatOpen) {
      props.toggleChat()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const handleToggleChat = () => {
    props.toggleChat()
  }

  return (
    <Navbar className="component-TopNav" variant="dark" fixed="top">
      <div className="container" style={{ position: 'relative' }}>
        {!!props.currentUser && Object.keys(props.currentUser).length !== 0 && props.currentUser.roles !== null && (
          <React.Fragment>
            <Navbar.Brand className="d-flex align-items-center mr-auto">
              <img
                src="/GuideSmart_logo-789x221.png"
                alt="GuideSmart Logo"
                style={{ height: '40px', objectFit: 'contain' }} // Using 40px as ~80-90% of typical navbar height
              />
            </Navbar.Brand>

            <Nav className="align-items-center">
              {/* Notifications */}
              <Nav.Item>
                <NotificationList currentUser={props.currentUser} />
              </Nav.Item>

              {/* Chat */}
              <Nav.Item>
                <Nav.Link onClick={handleToggleChat} className="position-relative" title="General Messages">
                  <FAIcon name="comments fa-lg" />
                  {chatUnreadCount > 0 && (
                    <Badge
                      variant="danger"
                      pill
                      style={{ position: 'absolute', top: '0', right: '0', fontSize: '0.6rem' }}
                    >
                      {chatUnreadCount}
                    </Badge>
                  )}
                </Nav.Link>
              </Nav.Item>

              {/* User Dropdown */}
              <NavDropdown
                title={
                  <span title="User Profile">
                    <FAIcon
                      name="user-circle fa-lg"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    />
                  </span>
                }
                id="user-nav-dropdown"
                alignRight
                className="ml-3 user-dropdown"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  Profile
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={props.handleLogout}>Sign out</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </React.Fragment>
        )}
      </div>
    </Navbar>
  )
}

export default TopNav
